import { getParam } from '../helpers/parameters'
import { attachBearerToken } from './attach-bearer-token'
import { fetchGetJson } from './fetch-get-json'

export const fetchContentApi = async (
  relativePath,
  config = { method: 'GET' },
  body
) => {
  const contentApiUrl = await getParam('contentApiUrl')

  const url = `${contentApiUrl}${relativePath}`
  return fetchGetJson(
    url,
    await attachBearerToken(attachBodyToConfig(config, body))
  )
}

const attachBodyToConfig = (config, body) => {
  if (typeof body !== 'string' || !isJson(body)) {
    return { ...config, body: JSON.stringify(body) }
  }
  return { ...config, body }
}
const isJson = str => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/services/content-api.js